import { type ThemeConfig, extendTheme } from "@chakra-ui/react";

import { colors } from "./colors";
import { components } from "./components";
import { styles } from "./styles";

const config: ThemeConfig = {
  initialColorMode: "system",
  useSystemColorMode: true,
};

const theme = extendTheme({ colors, components, config, styles });

export { theme };
